import "@fontsource-variable/plus-jakarta-sans";
import "@fontsource-variable/geist-mono";
import "./index.css";
import { APP_NAME } from "@custos/core";
import { Toaster } from "@custos/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { queryClient } from "./lib/api";
import { applyTheme, usePrefs, watchSystemTheme } from "./lib/prefs";

document.title = APP_NAME;
applyTheme(usePrefs.getState().theme);
watchSystemTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
